import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";

// String.title() polyfill — title-cases a string (replaces underscores/hyphens with spaces)
// eslint-disable-next-line no-extend-native
String.prototype.title = function () {
    if (this === "None" || this === "") return "-";
    return this
        .toLowerCase()
        .replace(/_/g, " ")
        .replace(/-/g, " ")
        .replace(/(^|\s)[a-z]/g, function (ch) { return ch.toUpperCase(); });
};

// Array.swapItems() polyfill — moves an item from oldIndex to newIndex (drag-and-drop reorder)
// eslint-disable-next-line no-extend-native
Array.prototype.swapItems = function (oldIndex, newIndex) {
    const arr = [...this];
    const [item] = arr.splice(oldIndex, 1);
    arr.splice(newIndex, 0, item);
    return arr;
};

const container = document.getElementById("root");
const root = createRoot(container);

// The page wrappers in src/Pages create their React.lazy component inside
// render. In a transition, a lazy component that suspends is re-created on
// every retry, so a navigation that stays on the same route (order to order,
// a search param change) never commits. Keep v6's synchronous navigation.
root.render(
    <BrowserRouter useTransitions={false}>
        <App />
    </BrowserRouter>
);
